module.exports = __webpack_public_path__ + "img/bbshomepage7.f766d6f2.png";